import { useTranslations } from '@vocab/react';
import { Box, Stack, Heading, Inline, Text } from 'braid-design-system';

import { useConfig } from 'src/provider/config';

import translations from './.vocab';

import * as styles from './Banner.css';

export const Banner = () => {
  const { t } = useTranslations(translations);
  const { countryCode, absoluteUrl } = useConfig();

  const headline = absoluteUrl !== '' ? t(`${countryCode}-headline`) : ' ';
  const subheading = absoluteUrl !== '' ? t(`${countryCode}-subheading`) : ' ';

  return (
    <Box display="flex" justifyContent="center">
      <Box
        background="brand"
        borderRadius="standard"
        paddingY={{
          desktop: 'xlarge',
        }}
        paddingX={{
          desktop: 'xlarge',
        }}
        id="top-banner"
        className={styles.BannerFormatting}
      >
        <Box
          paddingY={{
            desktop: 'xsmall',
          }}
        >
          <Stack space="large">
            <Heading
              align={{
                mobile: 'left',
                tablet: 'left',
              }}
              level="1"
              weight="regular"
              id="community-banner-heading"
            >
              {headline}
            </Heading>
            <Inline
              align={{
                mobile: 'left',
                tablet: 'left',
              }}
              space="xxsmall"
            >
              <Text
                size="large"
                weight="regular"
                align={{ desktop: 'left', mobile: 'left', tablet: 'left' }}
                id="community-banner-subheading"
              >
                {subheading}
              </Text>
            </Inline>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};
